import { Heart, Target, Users } from 'lucide-react';

import { useNamespace, useTranslation } from '@splitfiesta/i18n';

import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function AboutPage() {
  const { t } = useTranslation();
  const pagesLoaded = useNamespace('pages');

  if (!pagesLoaded) {
    return null;
  }

  return (
    <StaticPageLayout
      title={t('pages:about.title')}
      subtitle={t('pages:about.subtitle')}
    >
      <div className="prose prose-gray dark:prose-invert max-w-none">
        {/* Mission Section */}
        <section className="mb-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-orange-100 dark:bg-orange-900/30 rounded-lg flex items-center justify-center">
              <Target className="w-5 h-5 text-orange-600 dark:text-orange-400" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white m-0">
              {t('pages:about.mission.title')}
            </h2>
          </div>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:about.mission.description')}
          </p>
        </section>

        {/* Story Section */}
        <section className="mb-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-orange-100 dark:bg-orange-900/30 rounded-lg flex items-center justify-center">
              <Heart className="w-5 h-5 text-orange-600 dark:text-orange-400" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white m-0">
              {t('pages:about.story.title')}
            </h2>
          </div>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t('pages:about.story.paragraph1')}
          </p>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:about.story.paragraph2')}
          </p>
        </section>

        {/* Values Section */}
        <section>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-orange-100 dark:bg-orange-900/30 rounded-lg flex items-center justify-center">
              <Users className="w-5 h-5 text-orange-600 dark:text-orange-400" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white m-0">
              {t('pages:about.values.title')}
            </h2>
          </div>
          <ul className="list-none p-0 space-y-3">
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">•</span>
              <span className="text-gray-600 dark:text-gray-400">
                <strong className="text-gray-900 dark:text-white">
                  {t('pages:about.values.simplicity.title')}
                </strong>{' '}
                - {t('pages:about.values.simplicity.description')}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">•</span>
              <span className="text-gray-600 dark:text-gray-400">
                <strong className="text-gray-900 dark:text-white">
                  {t('pages:about.values.transparency.title')}
                </strong>{' '}
                - {t('pages:about.values.transparency.description')}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">•</span>
              <span className="text-gray-600 dark:text-gray-400">
                <strong className="text-gray-900 dark:text-white">
                  {t('pages:about.values.privacy.title')}
                </strong>{' '}
                - {t('pages:about.values.privacy.description')}
              </span>
            </li>
          </ul>
        </section>
      </div>
    </StaticPageLayout>
  );
}

export default AboutPage;
